import React from 'react';
import './styles.css';
import BETO from '../../img/beto.jpg';
import LOGO from '../../img/foco90.svg';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';

const RECUPERAR_SENHA = WS.recuperar;

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      loaded: false
    }

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount(){
    const self = this;
    const token = this.QueryString().token;

    if(!token){
      this.setState({
        noToken: true
      });

      return false;
    }

    this.setState({
      token
    });
    /*Requisitions({
      url: URL_LOGGED,
      data: {},
      sucess:function(data){
        if(data.status){
          window.dadosUser = data.user;
          self.props.history.push('/area-restrita/meu-treino/');
        }
      },
      error:function(data){
      }
    });*/
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    const senha = this.state.senha;
    const confirmacao_senha = this.state.confirmacao_senha;

    var self = this;
    const {
      atencao,
      salvoSucesso,
      preenchaTodosCampos,
      erroRecuperacaoSenha,
      senhasErradas
    }
    = this.state.strings;

    if(!confirmacao_senha && !senha){
      var msg = {
        title: atencao,
        text: preenchaTodosCampos
      };

      Dialog.create(msg);
      return false;
    }

    if(confirmacao_senha != senha){
      var msg = {
        title: atencao,
        text: senhasErradas
      };

      Dialog.create(msg);
      return false;
    }

    Requisitions({
      url: RECUPERAR_SENHA,
      data: {
        senha,
        token: self.state.token
      },
      sucess:function(data){
        if(data.status){
          setTimeout(()=>{
            self.props.history.push('/');
          },2000);
        }

        var msg = {
          title: atencao,
          text: data.msg
        };
        Dialog.create(msg);

      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroRecuperacaoSenha
        });
      }
    });
  }

  QueryString(){
    // This function is anonymous, is executed immediately and
    // the return value is assigned to QueryString!
    var query_string = {};
    var query = window.location.search.substring(1);
    var vars = query.split("&");

    for (var i=0;i<vars.length;i++)
    {
  	var pair = vars[i].split("=");

  	// If first entry with this name
  	if (typeof query_string[pair[0]] === "undefined")
  	{
  	  query_string[pair[0]] = decodeURIComponent(pair[1]);
  		// If second entry with this name
  	}
  	else if(typeof query_string[pair[0]] === "string")
  	{
  	  var arr = [ query_string[pair[0]],decodeURIComponent(pair[1]) ];
  	  query_string[pair[0]] = arr;
  		// If third or later entry with this name
  	}
  	else
  	{
  	  query_string[pair[0]].push(decodeURIComponent(pair[1]));
  	}
    }
  	return query_string;
  };

  render() {
    const box = this.state.noToken ?
    (<p class='invalid-token'>Dados inválidos para<br /> recuperação de senha</p>): (
      <form className="form-login"  onSubmit={this.handleSubmit}>
        <p class='title-recuperar'>Mudança de senha</p>
        <TextInput onChange={this.handleInputChange} name="senha" type="password" title="Nova Senha" placeholder="Digite aqui sua nova senha"></TextInput>
        <TextInput onChange={this.handleInputChange} name="confirmacao_senha" type="password" title="Confirmação de senha" placeholder="Digite aqui"></TextInput>
        <div className="box-center-button">
          <br />
          <Button type="submit" text="Enviar" classes="button-login simple-button" />
      </div>

      </form>
    );


    return (
      <div className="page-login" >
        <div className="wrapper-login">
          <div className="pure-g">
              <div className="pure-u-3-5">
                <div className="box-login">
                  <div className="box-login--inner">
                    <div className="box-login-logo"><img src={LOGO} /></div>
                    {box}
                  </div>
                </div>
              </div>
              <div className="pure-u-2-5 ">
                <img className="img-beto" src={BETO} />
              </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/classes/recuperar/RecuperarSenha.js